/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AIRelease = {
    readonly ai_release?: string;
    /**
     * The state of this AI version
     */
    status?: AIRelease.status;
    /**
     *
     * This field represent the current version of the AI being used.
     * A primary field can only have the `Running` state attached to it
     *
     */
    primary?: boolean;
}

export namespace AIRelease {

    /**
     * The state of this AI version
     */
    export enum status {
        RUNNING = 'Running',
        INACTIVE = 'Inactive',
        BLACKLISTED = 'Blacklisted',
    }


}
